module.exports = __webpack_public_path__ + "static/media/chadwicks.50be6bc9.png";